import { SET_ITEMS } from './types';

const setItemList = (items, vehicle) => {
	const { windowStickerUrl, account } = vehicle;
	const { webAddress } = account || null;
	const newItems = [];
	items.forEach(item => {
		const mappedItem = item;
		const { isWindowSticker, linkToParent, btnHref } = mappedItem;
		if (isWindowSticker && windowStickerUrl) {
			mappedItem.btnHref = windowStickerUrl;
		} else if (linkToParent && webAddress) {
			mappedItem.btnHref = `${webAddress}${btnHref}`;
		}
		if (mappedItem.btnHref) {
			newItems.push(mappedItem);
		}
	});
	return newItems;
};

export const setItems = (items, vehicle) => {
	return {
		type: SET_ITEMS,
		payload: setItemList(items, vehicle)
	};
};

export const getCtaClickTrackingObject = btnLabel => {
	const eventObject = {
		eventElementCTA: btnLabel,
		event: 'userEvent',
		eventAction: 'clicked',
		eventResult: 'Navigated to CTA destination',
		eventDescription: 'Visitor clicks a link/button',
		eventElement: 'CTA Button/Link',
		eventWidgetState: 'default',
		eventValue: undefined,
		eventWidgetName: 'ws-vehicle-ctas'
	};
	return eventObject;
};



// WEBPACK FOOTER //
// ./src/actions/items.js